import script from "./certificateReceiveInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./certificateReceiveInfo.vue?vue&type=script&setup=true&lang=js"

import "./certificateReceiveInfo.vue?vue&type=style&index=0&id=c8b89720&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b89720"]])

export default __exports__